import {
  configureStore,
} from '@reduxjs/toolkit'
import reducers from './reducers'

const store = configureStore({
  reducer: reducers,
  devTools: {
    name: 'Brand Settings',
  },
})

export default store
